import React, { Suspense, lazy, forwardRef } from 'react';

/*
 * @lordicon/react pulls in lottie-web, which is one of the heaviest
 * dependencies in the app. Loading it through React.lazy pushes it into its own
 * async chunk so it never blocks the initial render.
 *
 * The icon containers all have fixed dimensions in CSS, so the null fallback
 * reserves the exact same space and causes no layout shift.
 */
const Player = lazy(() =>
  import('@lordicon/react').then((module) => ({ default: module.Player }))
);

const LazyPlayer = forwardRef((props, ref) => (
  <Suspense fallback={null}>
    <Player ref={ref} {...props} />
  </Suspense>
));

LazyPlayer.displayName = 'LazyPlayer';

export default LazyPlayer;
